import { render, staticRenderFns } from "./rebateDetail.vue?vue&type=template&id=025ef590"
import script from "./rebateDetail.vue?vue&type=script&lang=js"
export * from "./rebateDetail.vue?vue&type=script&lang=js"
import style0 from "./rebateDetail.vue?vue&type=style&index=0&id=025ef590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports